import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PageAuth from "../pages/PageAuth/PageAuth";
import { isDev } from "../utils/dev";
import PageDashboard from "../pages/PageDashboard/PageDashBoard";
import PageEvents from "../pages/PageAllEvents/PageAllEvents";
import PageNewEvent from "../pages/PageEventCreate";
import PageEvent from "../pages/PageEvent/PageEvent";
import PageAction from "../pages/PageAction/PageAction";
import PageUsers from "../pages/PageUsers/PageUsers";
import PageActionCreate from "../pages/PageActionCreate/PageActionCreate";
import PageEventEdit from "../pages/PageEventEdit/PageEventEdit";
import PageActionEdit from "../pages/PageActionEdit/PageActionEdit";
import PageExtraction from "../pages/PageExtraction/PageExtraction";

type Props = {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isPilote: boolean;
  isPerformer: boolean;
};

// Dev only
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const debugByPassAuth = isDev && true;

const Router: React.FC<Props> = ({
  isAuthenticated,
  isPilote,
  isAdmin,
  isPerformer,
}) => {
  // if (debugByPassAuth) {
  //   return (
  //     <BrowserRouter>
  //       <Routes>
  //         <Route path="/" element={<Authentication />} />
  //       </Routes>
  //     </BrowserRouter>
  //   );
  // }

  if (!isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PageAuth />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (isPerformer) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PageDashboard />} />
          <Route path="/events/:eventId/actions/:id" element={<PageAction />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageDashboard />} />
        <Route path="/events/new" element={<PageNewEvent />} />
        <Route path="/events" element={<PageEvents />} />
        <Route path="/events/:id" element={<PageEvent />} />
        <Route path="/events/:eventId/actions/:id" element={<PageAction />} />
        <Route
          path="/events/:eventId/actions/new"
          element={<PageActionCreate />}
        />
        {isPilote && (
          <>
            <Route
              path="/events/:eventId/actions/:id/edit"
              element={<PageActionEdit />}
            />
          </>
        )}
        {isAdmin && (
          <>
            <Route path="/events/:id/edit" element={<PageEventEdit />} />
            <Route path="/users" element={<PageUsers />} />
            <Route path="/extraction" element={<PageExtraction />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
